// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Styles to make tables more compact, especially header spacing */
.table-compact thead th {
  padding-top: 0.14rem !important;
  padding-bottom: 0.14rem !important;
  line-height: 1.12 !important;
  font-size: 0.73rem !important;
}

.thead-custom {
  position: relative;
}

.thead-custom th {
  position: sticky;
  top: 0;
  z-index: 2;
  background: #0b3383 !important;
  color: #fff !important;
  border-bottom: none !important;
  white-space: nowrap;
}

.thead-custom th:first-child {
  border-radius: 0.5rem 0 0 0;
}

.thead-custom th:last-child {
  border-radius: 0 0.5rem 0 0;
}

.table-custom-radius {
  border-collapse: separate !important;
  border-spacing: 0;
}

.table-compact tbody td {
  padding-top: 0.18rem !important;
  padding-bottom: 0.18rem !important;
  line-height: 1.3 !important;
  white-space: normal !important;
  word-break: break-word !important;
  font-size: 0.73rem !important;
}

.table-compact thead th .small {
  line-height: 1 !important;
}

.table-very-small thead th,
.table-very-small tbody td {
  font-size: 0.68rem !important;
  padding-top: 0.08rem !important;
  padding-bottom: 0.08rem !important;
}

@media (max-width: 768px) {
  .table-responsive-sm table {
    min-width: 800px;
  }
  .table-responsive-sm table tbody td {
    white-space: nowrap !important;
    word-break: normal !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/service/components/css/TableContainer.css"],"names":[],"mappings":"AAAA,kEAAkE;AAClE;EACE,+BAA+B;EAC/B,kCAAkC;EAClC,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,8BAA8B;EAC9B,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,kCAAkC;EAClC,2BAA2B;EAC3B,8BAA8B;EAC9B,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,6BAA6B;EAC7B,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,8BAA8B;IAC9B,6BAA6B;EAC/B;AACF","sourcesContent":["/* Styles to make tables more compact, especially header spacing */\n.table-compact thead th {\n  padding-top: 0.14rem !important;\n  padding-bottom: 0.14rem !important;\n  line-height: 1.12 !important;\n  font-size: 0.73rem !important;\n}\n\n.thead-custom {\n  position: relative;\n}\n\n.thead-custom th {\n  position: sticky;\n  top: 0;\n  z-index: 2;\n  background: #0b3383 !important;\n  color: #fff !important;\n  border-bottom: none !important;\n  white-space: nowrap;\n}\n\n.thead-custom th:first-child {\n  border-radius: 0.5rem 0 0 0;\n}\n\n.thead-custom th:last-child {\n  border-radius: 0 0.5rem 0 0;\n}\n\n.table-custom-radius {\n  border-collapse: separate !important;\n  border-spacing: 0;\n}\n\n.table-compact tbody td {\n  padding-top: 0.18rem !important;\n  padding-bottom: 0.18rem !important;\n  line-height: 1.3 !important;\n  white-space: normal !important;\n  word-break: break-word !important;\n  font-size: 0.73rem !important;\n}\n\n.table-compact thead th .small {\n  line-height: 1 !important;\n}\n\n.table-very-small thead th,\n.table-very-small tbody td {\n  font-size: 0.68rem !important;\n  padding-top: 0.08rem !important;\n  padding-bottom: 0.08rem !important;\n}\n\n@media (max-width: 768px) {\n  .table-responsive-sm table {\n    min-width: 800px;\n  }\n  .table-responsive-sm table tbody td {\n    white-space: nowrap !important;\n    word-break: normal !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
